import APRequest from './rules/APRequest.json';
import APRequestItem from './rules/APRequestItem.json';
import APOrder from './rules/APOrder.json';
import APOrderItem from './rules/APOrderItem.json';
import APShipment from './rules/APShipment.json';
import APShipmentItem from './rules/APShipmentItem.json';
import APDelivery from './rules/APDelivery.json';
import APDeliveryItem from './rules/APDeliveryItem.json';
import APCredit from './rules/APCredit.json';
import APCreditItem from './rules/APCreditItem.json';
import APInvoice from './rules/APInvoice.json';
import APInvoiceItem from './rules/APInvoiceItem.json';
import APImportCost from './rules/APImportCost.json';
import APImportCostItem from './rules/APImportCostItem.json';

import ARPriceList from './rules/ARPriceList.json';
import ARPriceListItem from './rules/ARPriceListItem.json';

import ARPromotion from './rules/ARPromotion.json';
import ARPromotionItem from './rules/ARPromotionItem.json';
import AROrder from './rules/AROrder.json';
import AROrderItem from './rules/AROrderItem.json';
import ARShipment from './rules/ARShipment.json';
import ARShipmentItem from './rules/ARShipmentItem.json';
import ARDelivery from './rules/ARDelivery.json';
import ARDeliveryItem from './rules/ARDeliveryItem.json';
import ARCredit from './rules/ARCredit.json';
import ARCreditItem from './rules/ARCreditItem.json';
import ARInvoice from './rules/ARInvoice.json';
import ARInvoiceItem from './rules/ARInvoiceItem.json';
import AREvent from './rules/AREvent.json';
import ARTravel from './rules/ARTravel.json';
import ARAppointment from './rules/ARAppointment.json';
import ARRentalBooking from './rules/ARRentalBooking.json';
import ARServeAlwnRule from './rules/ARServeAlwnRule.json';
import ARServeAlwnRuleGlobal from './rules/ARServeAlwnRuleGlobal.json';
import ARServeAlwnRuleOnItem from './rules/ARServeAlwnRuleOnItem.json';

import ICReceipt from './rules/ICReceipt.json';
import ICReceiptItem from './rules/ICReceiptItem.json';
import ICReceiptDetail from './rules/ICReceiptDetail.json';
import ICIssue from './rules/ICIssue.json';
import ICIssueItem from './rules/ICIssueItem.json';
import ICIssueDetail from './rules/ICIssueDetail.json';
import ICReceiptDetailSerial from './rules/ICReceiptDetailSerial.json';
import ICAdjust from './rules/ICAdjust.json';
import ICAdjustItem from './rules/ICAdjustItem.json';
import ICTransfer from './rules/ICTransfer.json';
import ICTransferItem from './rules/ICTransferItem.json';
import ICTransferIssueItem from './rules/ICTransferIssueItem.json';
import ICTransferReceiptItem from './rules/ICTransferReceiptItem.json';
import ICTransferReturnItem from './rules/ICTransferReturnItem.json';
import ICCounting from './rules/ICCounting.json';
import ICCountingItem from './rules/ICCountingItem.json';
import ICCountingDetail from './rules/ICCountingDetail.json';
import ICInventory from './rules/ICInventory.json';
import ICMonthlyReport from './rules/ICMonthlyReport.json';
import ICValuation from './rules/ICValuation.json';
import ICBOM from './rules/ICBOM.json';
import ICBOMItem from './rules/ICBOMItem.json';
import ICAssemblyOrder from './rules/ICAssemblyOrder.json';
import ICAssemblyOrderItem from './rules/ICAssemblyOrderItem.json';

import SPCSourcingPolicy from './rules/SPCSourcingPolicy.json';
import SPCSourcingPolicyItem from './rules/SPCSourcingPolicyItem.json';
import SPCPurchaseByICRule from './rules/SPCPurchaseByICRule.json';
import SPCPurchaseByICRuleItem from './rules/SPCPurchaseByICRuleItem.json';
import SPCPurchaseByARRule from './rules/SPCPurchaseByARRule.json';
import SPCPurchaseByARRuleItem from './rules/SPCPurchaseByARRuleItem.json';

import LGOrder from './rules/LGOrder.json';
import LGOrderItem from './rules/LGOrderItem.json';
import LGTransport from './rules/LGTransport.json';

import HRWorkingSalary from './rules/HRWorkingSalary.json';
import HRWorkingSalaryItem from './rules/HRWorkingSalaryItem.json';
import HRAdjust from './rules/HRAdjust.json';
import HRAdjustItem from './rules/HRAdjustItem.json';
import HRCommision from './rules/HRCommision.json';
import HRCommisionItem from './rules/HRCommisionItem.json';
import HRAllowance from './rules/HRAllowance.json';
import HRAllowanceItem from './rules/HRAllowanceItem.json';
import HROrder from './rules/HROrder.json';
import HROrderItem from './rules/HROrderItem.json';
import HRCredit from './rules/HRCredit.json';
import HRCreditItem from './rules/HRCreditItem.json';
import HRAttendanceSite from './rules/HRAttendanceSite.json';
import HRAttendanceAssignment from './rules/HRAttendanceAssignment.json';
import HRAttendanceRecorderAssignment from './rules/HRAttendanceRecorderAssignment.json';
import HRLeaveType from './rules/HRLeaveType.json';

import CAAccount from './rules/CAAccount.json';
import CARequest from './rules/CARequest.json';
import CARequestItem from './rules/CARequestItem.json';
import CAApply from './rules/CAApply.json';
import CAIssue from './rules/CAIssue.json';
import CAIssueItem from './rules/CAIssueItem.json';
import CAReceive from './rules/CAReceive.json';
import CAReceiveItem from './rules/CAReceiveItem.json';
import CATransfer from './rules/CATransfer.json';
import CAAdjust from './rules/CAAdjust.json';

import Customer from './rules/Customer.json';
import CRMComsRule from './rules/CRMComsRule.json';
import CRMLead from './rules/CRMLead.json';
import SaleChannel from './rules/SaleChannel.json';
import Store from './rules/Store.json';
import ServePlace from './rules/ServePlace.json';
import RentalObject from './rules/RentalObject.json';
import Vendor from './rules/Vendor.json';
import GovEntity from './rules/GovEntity.json';
import Employee from './rules/Employee.json';
import Warehouse from './rules/Warehouse.json';
import Project from './rules/Project.json';

import BECashIn from './rules/BECashIn.json';
import BECashOut from './rules/BECashOut.json';

import UOM from './rules/UOM.json';
import Item from './rules/Item.json';
import Variant from './rules/Variant.json';
import BusinessEntity from './rules/BusinessEntity.json';
import CarrierService from './rules/CarrierService.json';

import EXPItem from './rules/EXPItem.json';
import EXPOrder from './rules/EXPOrder.json';
import EXPOrderItem from './rules/EXPOrderItem.json';
import EXPCredit from './rules/EXPCredit.json';
import EXPCreditItem from './rules/EXPCreditItem.json';
import EXPCost from './rules/EXPCost.json';
import EXPCostItem from './rules/EXPCostItem.json';
import EXPInvoice from './rules/EXPInvoice.json';
import EXPInvoiceItem from './rules/EXPInvoiceItem.json';
import FAAsset from './rules/FAAsset.json';
import FAAssetRegister from './rules/FAAssetRegister.json';
import FAAssetAdjInc from './rules/FAAssetAdjInc.json';
import FAAssetAdjDec from './rules/FAAssetAdjDec.json';
import FAAssetDispose from './rules/FAAssetDispose.json';

import FAEquipment from './rules/FAEquipment.json';
import FAEquipmentRegister from './rules/FAEquipmentRegister.json';
import FAEquipmentDispose from './rules/FAEquipmentDispose.json';

import EXROrder from './rules/EXROrder.json';
import EXROrderItem from './rules/EXROrderItem.json';
import EXRCredit from './rules/EXRCredit.json';
import EXRCreditItem from './rules/EXRCreditItem.json';
import EXRRevenue from './rules/EXRRevenue.json';
import EXRRevenueItem from './rules/EXRRevenueItem.json';
import EXRInvoice from './rules/EXRInvoice.json';
import EXRInvoiceItem from './rules/EXRInvoiceItem.json';

import MFWorkshop from './rules/MFWorkshop.json';
import MFStorage from './rules/MFStorage.json';
import MFLine from './rules/MFLine.json';
import MFProceduce from './rules/MFProceduce.json';
import MFRoute from './rules/MFRoute.json';
import MFBOM from './rules/MFBOM.json';
import MFBOMItem from './rules/MFBOMItem.json';
import MFMDSTicket from './rules/MFMDSTicket.json';
import MFMDSSummary from './rules/MFMDSSummary.json';
import MFMPS from './rules/MFMPS.json';
import MFMakeOrder from './rules/MFMakeOrder.json';
import MFWorkTicketActivity from './rules/MFWorkTicketActivity.json';
import MFWorkFinish from './rules/MFWorkFinish.json';
import MFWorkMoveActivity from './rules/MFWorkMoveActivity.json';
import MFMaterialIssueItem from './rules/MFMaterialIssueItem.json';
import ARServeBOM from './rules/ARServeBOM.json';
import ARServeMaterialCountingItem from './rules/ARServeMaterialCountingItem.json';

// import EXPAllocate from './rules/EXPAllocate.json';
// import EXPAllocateInput from './rules/EXPAllocateInput.json';
// import EXPAllocateOutput from './rules/EXPAllocateOutput.json';

// import GLAccount from './rules/GLAccount.json';
// import PNLCost from './rules/PNLCost.json';
// import PNLAccount from './rules/PNLAccount.json';
// import PNLRawPosting from './rules/PNLRawPosting.json';
// import PNLPosting from './rules/PNLPosting.json';
import PNLJournal from './rules/PNLJournal.json';
import GLJournal from './rules/GLJournal.json';
import GLMFCosting from './rules/GLMFCosting.json';

// import GLEntry from './rules/GLEntry.json';
import GLTrialBalance from './rules/GLTrialBalance.json';
import ACUserGroup from './rules/ACUserGroup.json';
import ACUserAccount from './rules/ACUserAccount.json';
import ACUserApproval from './rules/ACUserApproval.json';
import ACUserEmployee from './rules/ACUserEmployee.json';

var data = [];

data.push({ name: 'APRequest', value: APRequest });
data.push({ name: 'APRequestItem', value: APRequestItem });
data.push({ name: 'APOrder', value: APOrder });
data.push({ name: 'APOrderItem', value: APOrderItem });
data.push({ name: 'APShipment', value: APShipment });
data.push({ name: 'APShipmentItem', value: APShipmentItem });
data.push({ name: 'APDelivery', value: APDelivery });
data.push({ name: 'APDeliveryItem', value: APDeliveryItem });
data.push({ name: 'APCredit', value: APCredit });
data.push({ name: 'APCreditItem', value: APCreditItem });
data.push({ name: 'APInvoice', value: APInvoice });
data.push({ name: 'APInvoiceItem', value: APInvoiceItem });
data.push({ name: 'APImportCost', value: APImportCost });
data.push({ name: 'APImportCostItem', value: APImportCostItem });

data.push({ name: 'ARPriceList', value: ARPriceList });
data.push({ name: 'ARPriceListItem', value: ARPriceListItem });

data.push({ name: 'ARPromotion', value: ARPromotion });
data.push({ name: 'ARPromotionItem', value: ARPromotionItem });
data.push({ name: 'AROrder', value: AROrder });
data.push({ name: 'AROrderItem', value: AROrderItem });
data.push({ name: 'ARShipment', value: ARShipment });
data.push({ name: 'ARShipmentItem', value: ARShipmentItem });
data.push({ name: 'ARDelivery', value: ARDelivery });
data.push({ name: 'ARDeliveryItem', value: ARDeliveryItem });
data.push({ name: 'ARCredit', value: ARCredit });
data.push({ name: 'ARCreditItem', value: ARCreditItem });
data.push({ name: 'ARInvoice', value: ARInvoice });
data.push({ name: 'ARInvoiceItem', value: ARInvoiceItem });
data.push({ name: 'AREvent', value: AREvent });
data.push({ name: 'ARTravel', value: ARTravel });
data.push({ name: 'ARAppointment', value: ARAppointment });
data.push({ name: 'ARRentalBooking', value: ARRentalBooking });

data.push({ name: 'ARServeAlwnRule', value: ARServeAlwnRule });
data.push({ name: 'ARServeAlwnRuleGlobal', value: ARServeAlwnRuleGlobal });
data.push({ name: 'ARServeAlwnRuleOnItem', value: ARServeAlwnRuleOnItem });

data.push({ name: 'ICReceipt', value: ICReceipt });
data.push({ name: 'ICReceiptItem', value: ICReceiptItem });
data.push({ name: 'ICReceiptDetail', value: ICReceiptDetail });
data.push({ name: 'ICIssue', value: ICIssue });
data.push({ name: 'ICIssueItem', value: ICIssueItem });
data.push({ name: 'ICIssueDetail', value: ICIssueDetail });
data.push({ name: 'ICReceiptDetailSerial', value: ICReceiptDetailSerial });
data.push({ name: 'ICAdjust', value: ICAdjust });
data.push({ name: 'ICAdjustItem', value: ICAdjustItem });
data.push({ name: 'ICTransfer', value: ICTransfer });
data.push({ name: 'ICTransferItem', value: ICTransferItem });
data.push({ name: 'ICTransferIssueItem', value: ICTransferIssueItem });
data.push({ name: 'ICTransferReceiptItem', value: ICTransferReceiptItem });
data.push({ name: 'ICTransferReturnItem', value: ICTransferReturnItem });
data.push({ name: 'ICCounting', value: ICCounting });
data.push({ name: 'ICCountingItem', value: ICCountingItem });
data.push({ name: 'ICCountingDetail', value: ICCountingDetail });
data.push({ name: 'ICInventory', value: ICInventory });
data.push({ name: 'ICMonthlyReport', value: ICMonthlyReport });
data.push({ name: 'ICValuation', value: ICValuation });
data.push({ name: 'ICBOM', value: ICBOM });
data.push({ name: 'ICBOMItem', value: ICBOMItem });
data.push({ name: 'ICAssemblyOrder', value: ICAssemblyOrder });
data.push({ name: 'ICAssemblyOrderItem', value: ICAssemblyOrderItem });

data.push({ name: 'SPCSourcingPolicy', value: SPCSourcingPolicy });
data.push({ name: 'SPCSourcingPolicyItem', value: SPCSourcingPolicyItem });

data.push({ name: 'SPCPurchaseByICRule', value: SPCPurchaseByICRule });
data.push({ name: 'SPCPurchaseByICRuleItem', value: SPCPurchaseByICRuleItem });

data.push({ name: 'SPCPurchaseByARRule', value: SPCPurchaseByARRule });
data.push({ name: 'SPCPurchaseByARRuleItem', value: SPCPurchaseByARRuleItem });

data.push({ name: 'LGOrder', value: LGOrder });
data.push({ name: 'LGOrderItem', value: LGOrderItem });
data.push({ name: 'LGTransport', value: LGTransport });

data.push({ name: 'HRWorkingSalary', value: HRWorkingSalary });
data.push({ name: 'HRWorkingSalaryItem', value: HRWorkingSalaryItem });
data.push({ name: 'HRAdjust', value: HRAdjust });
data.push({ name: 'HRAdjustItem', value: HRAdjustItem });
data.push({ name: 'HRCommision', value: HRCommision });
data.push({ name: 'HRCommisionItem', value: HRCommisionItem });
data.push({ name: 'HRAllowance', value: HRAllowance });
data.push({ name: 'HRAllowanceItem', value: HRAllowanceItem });
data.push({ name: 'HROrder', value: HROrder });
data.push({ name: 'HROrderItem', value: HROrderItem });
data.push({ name: 'HRCredit', value: HRCredit });
data.push({ name: 'HRCreditItem', value: HRCreditItem });
data.push({ name: 'HRAttendanceSite', value: HRAttendanceSite });
data.push({ name: 'HRAttendanceAssignment', value: HRAttendanceAssignment });
data.push({ name: 'HRAttendanceRecorderAssignment', value: HRAttendanceRecorderAssignment });
data.push({ name: 'HRLeaveType', value: HRLeaveType });

data.push({ name: 'CAAccount', value: CAAccount });
data.push({ name: 'CARequest', value: CARequest });
data.push({ name: 'CARequestItem', value: CARequestItem });
data.push({ name: 'CAApply', value: CAApply });
data.push({ name: 'CAIssue', value: CAIssue });
data.push({ name: 'CAIssueItem', value: CAIssueItem });
data.push({ name: 'CAReceive', value: CAReceive });
data.push({ name: 'CAReceiveItem', value: CAReceiveItem });
data.push({ name: 'CATransfer', value: CATransfer });
data.push({ name: 'CAAdjust', value: CAAdjust });

data.push({ name: 'Customer', value: Customer });
data.push({ name: 'CRMComsRule', value: CRMComsRule });
data.push({ name: 'CRMLead', value: CRMLead });
data.push({ name: 'SaleChannel', value: SaleChannel });
data.push({ name: 'Store', value: Store });
data.push({ name: 'ServePlace', value: ServePlace });
data.push({ name: 'RentalObject', value: RentalObject });
data.push({ name: 'Vendor', value: Vendor });
data.push({ name: 'Supplier', value: Vendor });
data.push({ name: 'Carrier', value: Vendor });
data.push({ name: 'GovEntity', value: GovEntity });
data.push({ name: 'Employee', value: Employee });
data.push({ name: 'Warehouse', value: Warehouse });
data.push({ name: 'Project', value: Project });

data.push({ name: 'BECashIn', value: BECashIn });
data.push({ name: 'BECashOut', value: BECashOut });

data.push({ name: 'UOM', value: UOM });
data.push({ name: 'Item', value: Item });
data.push({ name: 'Variant', value: Variant });
data.push({ name: 'BusinessEntity', value: BusinessEntity });
data.push({ name: 'CarrierService', value: CarrierService });

data.push({ name: 'EXPItem', value: EXPItem });
data.push({ name: 'EXPOrder', value: EXPOrder });
data.push({ name: 'EXPOrderItem', value: EXPOrderItem });
data.push({ name: 'EXPCredit', value: EXPCredit });
data.push({ name: 'EXPCreditItem', value: EXPCreditItem });
data.push({ name: 'EXPCost', value: EXPCost });
data.push({ name: 'EXPCostItem', value: EXPCostItem });
data.push({ name: 'EXPInvoice', value: EXPInvoice });
data.push({ name: 'EXPInvoiceItem', value: EXPInvoiceItem });

data.push({ name: 'EXROrder', value: EXROrder });
data.push({ name: 'EXROrderItem', value: EXROrderItem });
data.push({ name: 'EXRCredit', value: EXRCredit });
data.push({ name: 'EXRCreditItem', value: EXRCreditItem });
data.push({ name: 'EXRRevenue', value: EXRRevenue });
data.push({ name: 'EXRRevenueItem', value: EXRRevenueItem });
data.push({ name: 'EXRInvoice', value: EXRInvoice });
data.push({ name: 'EXRInvoiceItem', value: EXRInvoiceItem });

data.push({ name: 'FAAsset', value: FAAsset });
data.push({ name: 'FAAssetRegister', value: FAAssetRegister });
data.push({ name: 'FAAssetAdjInc', value: FAAssetAdjInc });
data.push({ name: 'FAAssetAdjDec', value: FAAssetAdjDec });
data.push({ name: 'FAAssetDispose', value: FAAssetDispose });

data.push({ name: 'FAEquipment', value: FAEquipment });
data.push({ name: 'FAEquipmentRegister', value: FAEquipmentRegister });
data.push({ name: 'FAEquipmentDispose', value: FAEquipmentDispose });

data.push({ name: 'MFWorkshop', value: MFWorkshop });
data.push({ name: 'MFStorage', value: MFStorage });
data.push({ name: 'MFLine', value: MFLine });
data.push({ name: 'MFProceduce', value: MFProceduce });
data.push({ name: 'MFRoute', value: MFRoute });
data.push({ name: 'MFBOM', value: MFBOM });
data.push({ name: 'MFBOMItem', value: MFBOMItem });
data.push({ name: 'MFMDSTicket', value: MFMDSTicket });
data.push({ name: 'MFMDSSummary', value: MFMDSSummary });
data.push({ name: 'MFMPS', value: MFMPS });
data.push({ name: 'MFMakeOrder', value: MFMakeOrder });
data.push({ name: 'MFWorkTicketActivity', value: MFWorkTicketActivity });
data.push({ name: 'MFWorkFinish', value: MFWorkFinish });
data.push({ name: 'MFWorkMoveActivity', value: MFWorkMoveActivity });
data.push({ name: 'MFMaterialIssueItem', value: MFMaterialIssueItem });
data.push({ name: 'ARServeBOM', value: ARServeBOM });
data.push({ name: 'ARServeMaterialCountingItem', value: ARServeMaterialCountingItem });

// data.push({ name: 'EXPAllocate', value: EXPAllocate });
// data.push({ name: 'EXPAllocateInput', value: EXPAllocateInput });
// data.push({ name: 'EXPAllocateOutput', value: EXPAllocateOutput });

// data.push({ name: 'GLAccount', value: GLAccount });
data.push({ name: 'GLJournal', value: GLJournal });
data.push({ name: 'GLMFCosting', value: GLMFCosting });
// data.push({ name: 'GLEntry', value: GLEntry });
data.push({ name: 'GLTrialBalance', value: GLTrialBalance });

// data.push({ name: 'PNLAccount', value: PNLAccount });
// data.push({ name: 'PNLCost', value: PNLCost });
// data.push({ name: 'PNLRawPosting', value: PNLRawPosting });
// data.push({ name: 'PNLPosting', value: PNLPosting });
data.push({ name: 'PNLJournal', value: PNLJournal });

data.push({ name: 'ACUserGroup', value: ACUserGroup });
data.push({ name: 'ACUserAccount', value: ACUserAccount });
data.push({ name: 'ACUserApproval', value: ACUserApproval });
data.push({ name: 'ACUserEmployee', value: ACUserEmployee });

export default data;
